import Vue from 'vue';
import { formatDate, formatDateTime } from 'mycorems-app-shared';
import { setSubscribeHandler, setUnsubscribeHandler } from 'mycorems-app-accounts';
import './billing/init';
import './error-handler/init';
import './routing/init';
import './quasar';
import './accounts/init';
import router from './routing/router';
import App from './App.vue';
import { money, round } from './utils';
import { subscribeHandler, unsubscribeHandler } from './account-subscriber';

Vue.filter('money', cents => money(cents));
Vue.filter('round', value => round(value));
Vue.filter('date', date => formatDate(date));
Vue.filter('datetime', datetime => formatDateTime(datetime));

setSubscribeHandler(subscribeHandler);
setUnsubscribeHandler(unsubscribeHandler);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
